import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { Label, Select, Block, Button, Icon } from '../../../../components';
import { FileUploader } from '../../components';
import { SubContainer } from '../certificates-constancies/type1/info/components';
import Processing from '@/presentation/components/Processing';
import ErrorMessage from './components/ErrorMessage';
import routes from '../../../../components/Routes/routingMap';
import ModalConfirmation from '../../components/Modal/Modal';
import ConfirmationQuit from '../requests/ChangeCareerCampusModality/register/components/ConfirmationQuit';
import FileHelper from '../../../../../core/helpers/FileHelper';
import './styles.css';
import SuccessMessage from './components/SuccessMessage';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ModuleContainer from '@/presentation/components/Container';

const FieldLabel = ({ children }: any) => (
  <Block data-testid="cmp-block-view" className="labelFieldName">
    {children}
  </Block>
);

const RowField = ({ children }: any) => (
  <div
    data-testid="cmp-row-field"
    style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
  >
    {children}
  </div>
);

export const InputField = ({
  value,
  setValue,
  textarea,
  placeholder,
  showCount,
  maxLength,
  isNumber,
  error,
  errorText,
  name,
  disabled = false
}: any) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
    {textarea && (
      <textarea
        disabled={disabled}
        data-testid="cmp-textarea-field-register-ticket"
        style={{ width: '100%', padding: '12px 16px 0 16px' }}
        className={`${value ? 'inputFilled' : ''} ${
          maxLength < value.length ? 'inputError' : ''
        }`}
        value={value}
        onChange={(e) => {
          setValue({ name, value: e.target.value });
        }}
        rows={5}
        placeholder={placeholder}
      />
    )}
    {!textarea && (
      <input
        data-testid="cmp-input-register-ticket"
        type="text"
        className={`${value ? 'inputFilled' : ''} ${error ? 'inputError' : ''}`}
        value={value}
        onChange={(e) => {
          if (isNumber) {
            setValue({
              name,
              value: e.target.value
                .replace(/[^0-9.]/g, '')
                .replace(/(\..*)\./g, '$1')
                .replace(/\./g, '')
            });
            return;
          }
          setValue({ name, value: e.target.value });
        }}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    )}
    {showCount && (
      <div
        className="inputFooter"
        style={{
          justifyContent: error ? 'space-between' : 'flex-end',
          display: 'flex',
          fontSize: '12px',
          lineHeight: '16px',
          fontWeight: 400
        }}
      >
        {error && (
          <div className="errorText">
            <Icon name="alert-triangle" size={12} />
            {errorText}
          </div>
        )}
        {value.length} / {maxLength}
      </div>
    )}
  </div>
);
const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);
interface RegisterTicketViewProps {
  fields: any;
  errors: any;
  formIsValid: boolean;
  showConfirmCancel: boolean;
  isLoadingData: boolean;
  proceduresList: any;
  isLoadingRegister: boolean;
  isSuccess: boolean;
  error: any;
  selectedItem: any;
  setFieldValue: ({ name, value }: any) => void;
  setFieldError: ({ name, value }: any) => void;
  handlerBackButton: () => void;
  handlerBackButtonConfirm: () => void;
  handlerBackButtonCancel: () => void;
  registerTicket: () => void;
  clearError: () => void;
}
const RegisterTicketView = (props: RegisterTicketViewProps) => {
  const history = useHistory();
  const {
    fields,
    errors,
    formIsValid,
    showConfirmCancel,
    isLoadingData,
    proceduresList,
    isLoadingRegister,
    isSuccess,
    error,
    selectedItem,
    setFieldValue,
    setFieldError,
    handlerBackButton,
    handlerBackButtonConfirm,
    handlerBackButtonCancel,
    registerTicket,
    clearError
  } = props;
  const { phone, detail, authorize } = fields;
  const { detail: errorDetail, phone: errorPhone } = errors;
  const charactersLength = 2000;
  const validateField = ({ name, value }: any) => {
    const validator: { [key: string]: boolean } = {
      email: value === '' ? false : !validEmailRegex.test(value),
      detail: value.length > charactersLength,
      phone: value.length > 0 && value.length < 6
    };
    setFieldError({ name, value: validator[name] });
    setFieldValue({ name, value });
  };
  const checkHandler = (event: any) => {
    const e = event;
    setTimeout(() => {
      e.target.blur();
      e.target.parentNode.blur();
    }, 100);

    setFieldValue({ name: 'authorize', value: !authorize });
  };

  return (
    <ModuleContainer containerType="subsection">
      <ModalConfirmation
        show={showConfirmCancel}
        handleClose={handlerBackButtonCancel}
      >
        <ConfirmationQuit
          handleQuit={handlerBackButtonConfirm}
          handleCancel={handlerBackButtonCancel}
        />
      </ModalConfirmation>

      <SubContainer>
        <Block flex className="RegisterForm">
          <Block
            className="RegisterFormContainer"
            style={{ width: isMobile ? '100%' : '744px' }}
          >
            <SubsectionHeader
              title="Solicitudes SAE"
              onClick={handlerBackButton}
            />
            <div className="rowFields">
              <RowField>
                <FieldLabel>Tipo</FieldLabel>
                <Select
                  value={{
                    value: selectedItem?.id,
                    label: selectedItem?.name
                  }}
                  isLoading={isLoadingData}
                  isFilterable
                  isDisabled={isLoadingData}
                  maxOptionsToFilter={15}
                  minCharactersToFilter={3}
                  options={proceduresList?.map((item: any) => ({
                    value: item.id,
                    label: item.name
                  }))}
                  placeholder="Selecciona un tipo de trámite"
                  handleChangeSelect={(e) => {
                    setFieldValue({ name: 'procedureId', value: e.value });
                  }}
                />
              </RowField>
              <RowField>
                <FieldLabel>Información de contacto</FieldLabel>
                <div className="grid grid-cols-4 gap-md">
                  <div className="col-span-4 md:col-span-4">
                    <InputField
                      value={phone}
                      setValue={validateField}
                      name="phone"
                      placeholder="Ingresa tu número telefónico"
                      showCount
                      maxLength={11}
                      isNumber
                      errorText="Ingresa un número de teléfono válido"
                      error={errorPhone}
                    />
                  </div>
                </div>
              </RowField>
              <RowField>
                <FieldLabel>Detalle de solicitud</FieldLabel>
                <InputField
                  value={detail}
                  setValue={validateField}
                  placeholder="Escribe aquí el detalle"
                  textarea
                  showCount
                  maxLength={charactersLength}
                  error={errorDetail}
                  errorText="Excediste el número de caracteres"
                  name="detail"
                />
              </RowField>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div>
                  <input
                    className="checkbox__register-ticket"
                    data-testid="cmp-check-handler"
                    type="checkbox"
                    onChange={checkHandler}
                    checked={authorize}
                    disabled={detail === ''}
                  />
                  <button
                    data-testid="cmp-check-handler-btn"
                    type="button"
                    onClick={(e) => {
                      checkHandler(e);
                    }}
                    className="control_indicator fadeTransition"
                    aria-label="button"
                  >
                    <Block
                      className="control_indicator_2"
                      onClick={(event: any) => checkHandler(event)}
                    />
                  </button>
                </div>
                <Label
                  size={14}
                  lineHeight={18}
                  color={
                    detail !== ''
                      ? 'var(--text-text02)'
                      : 'var(--text-text-disabled)'
                  }
                  text="Acepto recibir comunicaciones de  carácter administrativo y/o relacionados a los servicios que presta la Universidad al teléfono y correo ingresados."
                />
              </div>
              <RowField>
                <p
                  style={{
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#161D1F'
                  }}
                >
                  Adjuntar evidencia:{' '}
                  <b
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      lineHeight: '20px',
                      color: '#161D1F'
                    }}
                  >
                    (Opcional)
                  </b>
                </p>
                <FileUploader
                  title=""
                  allowedFormats=".jpeg,.jpg,.png,.pdf"
                  displayFormats="JPG, PNG, PDF"
                  maxFileSize={5}
                  maxAllowFiles={5}
                  onFilesError={(e: any) => {
                    setFieldError({ name: 'files', value: e.filesCount > 0 });
                    setFieldValue({ name: 'files', value: [] });
                  }}
                  onFilesClean={() => {
                    setFieldError({ name: 'files', value: false });
                    setFieldValue({ name: 'files', value: [] });
                  }}
                  onFilesReady={(myFiles: any) => {
                    setFieldError({ name: 'files', value: false });
                    setFieldValue({
                      name: 'files',
                      value: FileHelper.toBase64(myFiles)
                    });
                  }}
                />
              </RowField>
              <RowField>
                <Button
                  disable={!formIsValid}
                  disabled={!formIsValid}
                  expand={isMobile}
                  value="Solicitar"
                  onClick={registerTicket}
                  className="buttonSolicitar"
                />
              </RowField>
            </div>
          </Block>
        </Block>
      </SubContainer>
      <ModalConfirmation show={error} handleClose={clearError}>
        <ErrorMessage onClickPrimary={clearError} />
      </ModalConfirmation>
      <ModalConfirmation
        show={isSuccess}
        handleClose={() => {
          history.push(routes.student.procedures.home);
        }}
      >
        <SuccessMessage
          onClickPrimary={() => {
            history.push(routes.student.procedures.home);
          }}
          onClickSecondary={() => {
            history.push(routes.student.procedures.home);
          }}
        />
      </ModalConfirmation>
      <Processing isOpen={isLoadingRegister} />
    </ModuleContainer>
  );
};
export default RegisterTicketView;
